import type { TtqWorkbenchSourceParticleGroupItem } from './TtqWorkbenchSourceParticle';
import type { TtqSessionParticleEntry } from '../../services/ttqService';
import { resolveTtqParticleTitle } from '../../utils/ttqDisplay';

/** 从会话颗粒条目构建工作台源颗粒 Group 数据 */
export function buildTtqWorkbenchSourceGroupItems(
  entries: TtqSessionParticleEntry[],
  particleIds?: string[],
): TtqWorkbenchSourceParticleGroupItem[] {
  const filtered = particleIds?.length
    ? entries.filter((e) => particleIds.includes(e.particleId))
    : entries;
  return filtered.map((entry, index) => ({
    particleId: entry.particleId,
    title: resolveTtqParticleTitle(entry, index),
  }));
}
